import { Route } from "react-router-dom";

import AdminDashBoard from "../Pages/Dashboard/AdminDashBoard";
import DashboardHome from "../Pages/Dashboard/DashboardHome";
import CompaniesList from "../Pages/Dashboard/CompaniesList";
import CompanyInformation from "../Pages/Company/CompanyInformation";
import CompanyTable from "../Pages/Manage/CompanyTable";
import IndexCompanyTable from "../Pages/Manage/IndexCompanyTable";
import SectorTable from "../Pages/Manage/SectorTable";
import Settings from "../Pages/Settings/Settings";
import IndexDashboard from "../Pages/Dashboard/IndexDashboard";
import HomeLayout from "../themes/Home/HomeLayout";
import PrivateRoute from "./PrivateRoute";
import AITraderPage from "../Pages/AITrader/AITraderPage";
import MarketPulseDashboard from "../Pages/Dashboard/MarketPulseDashboard";
import TradingPage from "../Pages/Trading/TradingPage";
import MirrorPage from "../Pages/Mirror/MirrorPage";

const HomeRoutes = () => {
  return (
    <Route
      path="/"
      element={
        <PrivateRoute>
          <HomeLayout />
        </PrivateRoute>
      }
    >
      <Route path="/dashboard" element={<DashboardHome />} />
      <Route path="/dashboard/companies" element={<CompaniesList />} />
      <Route path="/company/:id" element={<CompanyInformation />} />
      <Route path="/company-table" element={<CompanyTable />} />
      <Route path="/index-table" element={<IndexCompanyTable />} />
      <Route path="/sector" element={<SectorTable />} />
      <Route path="/index-dashboard/:symbol?" element={<IndexDashboard />} />
      <Route path="admin/settings" element={<Settings />} />
      <Route path="/ai-trader" element={<AITraderPage />} />
      <Route path="/market-pulse" element={<MarketPulseDashboard />} />
      <Route path="/trading" element={<TradingPage />} />
      <Route path="/mirror" element={<MirrorPage />} />
    </Route>
  );
};

export default HomeRoutes;
